import { useEffect, useRef, useState } from "react";
import { token, domain } from "../../../../../components/Security";
import axios from "../../../../../api/apiClient";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";

import { SetAuditTrail } from "../../../../../components/Reports/AuditTrailReportEmployeeSetup";
import { PayTypeIdSelect } from "../selects/PayTypeIdSelect";
import { ClassificationIdSelectFilter } from "../selects/ClassificationIdSelectFilter";
import { CustomLoader } from "../utils/CustomLoader";
import { PayrollPeriodIdSelectFilter2 } from "../selects/PayrollPeriodIdSelectFilter2";

export function SyncLateAdjustment({
	isOpen,
	onClose,
	fetchOtherAddition,
	fetchOtherDeduction,
	fetchOtherAdjustment,
	fetchLateAdjustmentData,
	fetchProcess,
	setIsProcess,
	isGenerate,
	mainPayrollPeriod,
	user,
}) {
	const [loadingPercentage, setLoadingPercentage] = useState(0);
	const [loadingRequest, setLoadingRequest] = useState(false);
	const [errorState, setErrorState] = useState(false);
	const [payrollPeriodId, setPayrollPeriodId] = useState("");
	const [payTypeId, setPayTypeId] = useState("");
	const [classificationId, setClassificationId] = useState("");
	//Request Messages -start
	const [showRequestMessage, setShowRequestMessage] = useState(false);
	const [requestMessage, setRequestMessage] = useState("");
	const [isSuccess, setIsSuccess] = useState("");
	useEffect(() => {
		if (showRequestMessage) {
			const timeoutId = setTimeout(() => {
				setShowRequestMessage(false);
			}, 5000);

			return () => clearTimeout(timeoutId);
		}
	}, [showRequestMessage]);
	function GenerateMessage({ form, message, isSuccess }) {
		return (
			<>
				<div
					className={`modal-overlay toggleMessage-overlay ${form ? "open" : ""
						}`}
				>
					{form && (
						<div
							className="modal toggleMessage"
							style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
						>
							<div className="column">
								{isSuccess ? (
									<div
										className="request_title row"
										style={{
											fontWeight: "bold",
											color: "green",
											alignItems: "center",
										}}
									>
										<CheckCircleIcon />
										<span>{"SUCCESS MESSAGE"}</span>
									</div>
								) : (
									<div
										className="request_title row"
										style={{
											fontWeight: "bold",
											color: "#DD5746",
											alignItems: "center",
										}}
									>
										<ErrorIcon />
										<span>{"ERROR MESSAGE"}</span>
									</div>
								)}
								<span
									style={{
										textAlign: "center",
										padding: "10px 0",
										color: isSuccess ? "green" : "#DD5746",
									}}
								>
									{message}
								</span>
							</div>
						</div>
					)}
				</div>
			</>
		);
	}
	//Request Messages -end

	const submit = (e) => {
		if (!payrollPeriodId || !payTypeId || !classificationId) {
			setErrorState(true);
			return;
		}
		handleClose();
		handleProcess(e);
		setErrorState(false);
		// setIsProcess(true);
	};

	const handleClose = () => {
		onClose();
		setPayrollPeriodId("");
		setPayTypeId("");
		setClassificationId("");
		setErrorState(false);
	};

	const apiUrlRef = useRef(domain + `/api/OtherAdjustmentStaging`);

	const handleProcess = async (event) => {
		event.preventDefault();
		// const apiUrl = apiUrlRef.current + `/process/${payTypeId}/${payrollPeriodId}/classification/${classificationId}`;
		const apiUrl =
			apiUrlRef.current +
			`/generate-late-approval-adjustments/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}/main-payrollperiod/${mainPayrollPeriod}`;
		let progress = 10; // Start progress at 10%

		// Gradually increase progress while waiting for long API calls
		const simulateLoading = (targetPercentage, intervalTime = 500) => {
			return new Promise((resolve) => {
				const interval = setInterval(() => {
					if (progress < targetPercentage) {
						progress += 1; // Increase by 1% every interval
						setLoadingPercentage(progress);
					} else {
						clearInterval(interval);
						resolve(); // Stop when reaching the target percentage
					}
				}, intervalTime); // Adjust interval time for smoother/slower increments
			});
		};

		try {
			setLoadingPercentage(10); // Initial 10%
			setLoadingRequest(true);

			// Simulate gradual loading progress while waiting for axios.post
			simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step

			// Actual axios call
			await axios.post(apiUrl, null, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			});

			setLoadingPercentage(30); // Set immediate jump to 40% after axios call finishes

			await SetAuditTrail({
				setupArea: "Payroll",
				actionTaken: "process",
				field: "Process Payroll",
				newValue: `-`,
				oldValue: "-",
				dateSaved: new Date(),
				savedById: user.id,
			});

			await simulateLoading(60, 100);

			await fetchOtherAddition();

			// Simulate gradual progress to 70%
			await simulateLoading(70, 100);

			await fetchOtherDeduction();

			// Simulate gradual progress to 80%
			await simulateLoading(80, 100);

			await fetchOtherAdjustment();
			await fetchLateAdjustmentData();

			// Simulate gradual progress to 90%
			await simulateLoading(90, 100);

			await fetchProcess();

			setShowRequestMessage(true);
			setIsSuccess(true);

			// Final smooth increase to 95%
			simulateLoading(95, 100);
			handleClose();
		} catch (error) {
			// Stop any ongoing simulation
			setLoadingPercentage(progress); // Stop at the current percentage
			setLoadingRequest(false); // Set the loading state to false

			setShowRequestMessage(true);
			setIsSuccess(false);
			console.error("Error:", error);
			const errorMessage = JSON.parse(
				error.response.request.responseText
			).message;
			setRequestMessage(errorMessage); // Optionally simulate slow reset to 0 to show failure state

			await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
		} finally {
			// Finalize loading process and reset
			await simulateLoading(100, 100); // Gradually increment to 100% before closing
			setTimeout(() => {
				setLoadingPercentage(0);
				setLoadingRequest(false);
			}, 500); // Delay to show full completion before resetting
		}
	};

	const [currentPayTypeId, setCurrentPayTypeId] = useState("");
	useEffect(() => {
		if (currentPayTypeId !== payTypeId) {
			setCurrentPayTypeId(payTypeId);
			setClassificationId("");
			setPayrollPeriodId("");
		}
	}, [currentPayTypeId, payTypeId]);

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Sync Adjustment</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div
							className="popUp-body column"
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Pay Type</div>
								<div className="info-item-input">
									<PayTypeIdSelect
										payTypeId={payTypeId}
										setPayTypeId={setPayTypeId}
									/>
								</div>
								<span
									style={{
										visibility: !payTypeId && errorState ? "visible" : "hidden",
										color: "#ff6565",
										fontSize: "12px",
									}}
								>
									Please fill up this field
								</span>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Late Payroll Period</div>
								<div className="info-item-input">
									<PayrollPeriodIdSelectFilter2
										payrollPeriodId={payrollPeriodId}
										setPayrollPeriodId={setPayrollPeriodId}
										payTypeId={payTypeId}
										mainPayrollPeriod={mainPayrollPeriod}
									/>
								</div>
								<span
									style={{
										visibility:
											(!payrollPeriodId && errorState) || !payTypeId
												? "visible"
												: "hidden",
										color: "#ff6565",
										fontSize: "12px",
									}}
								>
									{!payTypeId
										? "Please select Pay Type first"
										: "Please fill up this field"}
								</span>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Classification Type</div>
								<div className="info-item-input">
									<ClassificationIdSelectFilter
										user={user}
										classificationId={classificationId}
										setClassificationId={setClassificationId}
										payTypeId={payTypeId}
									/>
								</div>
								<span
									style={{
										visibility:
											(!classificationId && errorState) || !payTypeId
												? "visible"
												: "hidden",
										color: "#ff6565",
										fontSize: "12px",
									}}
								>
									{!payTypeId
										? "Please select Pay Type first"
										: "Please fill up this field"}
								</span>
							</div>
						</div>
						<div
							className="buttons row"
							style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}
						>
							<button
								id="add-family"
								className="save row"
								onClick={(e) => submit(e)}
								style={{ marginRight: "5px" }}
							>
								SYNC
							</button>
						</div>
					</div>
				)}
			</div>
			<GenerateMessage
				form={showRequestMessage}
				message={isSuccess ? "Request Success!" : requestMessage}
				isSuccess={isSuccess}
			></GenerateMessage>
			{loadingRequest ? (
				<CustomLoader loadingPercentage={loadingPercentage} />
			) : (
				<></>
			)}
		</>
	);
}